import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { TableComponentProps } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

const columnLables = {
  aum_amount_in_euro: {
    name: 'In EURO',
    type: 'customNumber',
    letter: 'A',
    order: 21
  },
  aum_amount_in_base_currency: {
    name: 'In base currency (if this is the same for all AIFs)',
    type: 'customNumber',
    letter: 'A',
    order: 22
  },
  base_currency: {
    name: 'Base currency',
    type: 'customText',
    letter: 'A',
    order: 23
  },
  fx_eur_rate: {
    name: 'EURO FX rate',
    type: 'customNumber',
    letter: 'A',
    order: 24
  },
  fx_eur_reference_rate_type: {
    name: 'Type of FX reference rate used',
    letter: 'A',
    type: 'customText',
    order: 25
  },
  fx_eur_other_reference_rate_description: {
    name: 'Source of EURO reference rate not published by the ECB',
    type: 'customText',
    letter: 'A',
    order: 26
  }
};

export function BaseCurrencyAIF001({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.AIFM_BASE_CURRENCY_DESCRIPTION,
    onChangeFund,
    schema: schema.AIFM_BASE_CURRENCY_DESCRIPTION,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.AIFM_BASE_CURRENCY_DESCRIPTION?.field_names || [],
    isMultiFunds,
    funds,
    columnLables,
    tableName: 'AIFM_BASE_CURRENCY_DESCRIPTION'
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.AIFM_BASE_CURRENCY_DESCRIPTION?.field_names?.length ===
    0;

  const errors = funds[currentDataKey]?.fund_data?.AIFM_BASE_CURRENCY_DESCRIPTION?.find(
    item => item?.errors?.general
  )?.errors?.general as any;

  return (
    <>
      <Errors id="fca-reporttables-base-currency-aif001-errors">
        {isRequiredTable && (
          <li id="fca-reporttables-base-currency-aif001-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map(item => (
          <li
            key={item.msg}
            id={`fca-reporttables-base-currency-aif001-error-${idCreator(item.msg)}`}
          >
            {item.msg}
          </li>
        ))}
      </Errors>

      <Table
        id="fca-reporttables-base-currency-aif001-table"
        handleChanges={onChange}
        columns={columns}
        rows={rows}
        stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      />
    </>
  );
}
